import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  input,
  output,
  ViewChild
} from '@angular/core';
import { Link } from '@com-delta-idp/mnx-ui-kit';
import {
  MachTier,
  MedallionBannerAriaLabel
} from '../../models/medallion-banner.interfaces';
import { Details, TooltipMetaData } from './models/details.interfaces';

@Component({
  selector: 'idp-details',
  standalone: true,
  imports: [],
  templateUrl: './details.component.html',
  styleUrl: './details.component.scss'
})
export class DetailsComponent implements AfterViewInit {
  content = input<Details>({} as Details);
  ariaLabel = input<MedallionBannerAriaLabel>({} as MedallionBannerAriaLabel);
  analytics = output<Link>();
  @ViewChild('title') title!: ElementRef;

  ellipsisActive = false;
  protected _titleWidth = 0;
  tooltipData: TooltipMetaData = {} as TooltipMetaData;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  getLogoUrl(tier: MachTier): string {
    return tier.name === '360'
      ? `var(--aura-medallion-banner-${tier.name}-${tier.level})`
      : `var(--aura-medallion-banner-${tier.level})`;
  }

  ngAfterViewInit(): void {
    this.updateTitleWidth();
    this.init(this.title);
  }

  init(title: ElementRef) {
    this.ellipsisActive = this.validateEllipsis(title);
    this.changeDetectorRef.detach();
    this.changeDetectorRef.detectChanges();
  }

  validateEllipsis(title: ElementRef): boolean {
    return title?.nativeElement.offsetWidth < title?.nativeElement.scrollWidth;
  }

  @HostListener('window:resize')
  windowResize() {
    this.updateTitleWidth();
  }

  updateTitleWidth() {
    this._titleWidth = this.title?.nativeElement.parentElement.offsetWidth - 40;
    this.changeDetectorRef.detectChanges();
  }
}
